import { FC, Modal, PropsWithChildren, useMemo} from 'external/react'
import useParent from 'context/parent-context/hook'
import SubscriptionStatus from 'components/SubscriptionStatus'
import { convertDateToText } from 'utilities/text'
import Icon, { IconName } from 'external/fortawesome'
import PackageModalHeader from './PackageModalHeader'

type PaymentDetailsProps = {
    handleClose: () => void 
}

type DetailItemProps = {
  label: string
  icon?: IconName
}

const DetailItem:FC<PropsWithChildren<DetailItemProps>> = props => {
  const {children, label, icon} = props
  return (
     <div className='col-lg-12 col-md-12 col-12 px-4 mb-3'>
      <span className='fw-500 mr-1'>{icon ? (<><Icon name={icon} className='mr-1' />{label}</>) : label}</span>
      {children}
    </div>
  )
}

const PaymentDetails:FC<PaymentDetailsProps> = props => {

  const {state: {payments, paymentDetailIndex}} = useParent()
  const {handleClose} = props 
  const [show, payment] = useMemo(() => paymentDetailIndex === false
    ? [false, {} as any]
    : [true, payments.items[paymentDetailIndex]]
  , [paymentDetailIndex])

  const {purchaseDate, subscriptionStatus, subscriptionEnds, paymentMode, card, last4} = payment
  const statusLabel = useMemo(() => {
    if (paymentMode === 'payment') return 'Fecha de expiración:'
    switch(subscriptionStatus) {
      case 'active': return 'Próximo pago:'
      case 'pending': return 'Suscripción vigente hasta el:'
      case 'canceled': return 'Suscripción cancelada:'
      case 'past_due': return 'Pago no realizado:'
      default: return 'Próximo pago:'
    }
  }, [paymentMode, subscriptionStatus])

  const [courses, electives] = useMemo(() => Array.isArray(payment.courses)
    ? [ payment.courses.filter(id => !/^C7/.test(id)), payment.courses.filter(id => /^C7/.test(id)) ]
    : [[], []], [payment.courses])

  return (
    <Modal show={show} onHide={handleClose} size='lg' centered >
      <PackageModalHeader index={paymentDetailIndex} />
      <Modal.Body>
      <DetailItem label='Estado'>
        {payment.paymentMode === 'subscription' && <SubscriptionStatus status={payment.subscriptionStatus} subscription={payment.subscription} />}
      </DetailItem>
      <DetailItem label='Miembro desde:' icon='faCalendarDays'>
            {convertDateToText(purchaseDate, true)}
      </DetailItem>
      <DetailItem label={statusLabel} icon='faCalendarDays'>
            {convertDateToText(subscriptionEnds, true)}
      </DetailItem>
      <DetailItem label="Cursos principales:" icon='faPuzzlePiece'>{courses.length}</DetailItem>
      <DetailItem label="Electivas:" icon='faPuzzlePiece'>{electives.length}</DetailItem>
      <DetailItem label="Tipo de tarjeta:" icon='faCreditCard'>{card}</DetailItem>
      <DetailItem label="Tarjeta:" icon='faCreditCard'>{last4}</DetailItem>
      </Modal.Body>
    </Modal>
  )
}

export {PaymentDetails as default}